<template>
  <div class="video-outer">
    <video
      class="video"
      :width="width"
      :height="height"
      :poster="poster_img"
      autoplay="true"
      loop="true"
      muted="true"
      playsinline
    >
      <source 
        v-for="(url, index) in source"
        :key="index"
        :src="url" 
      />
    </video>
  </div>
</template>

<script>
export default {
  name: "fcwpVideo",
  props: ['video', 'poster'],
  data() {
    return {
      width: null,
      height: null,
      source: [],
      poster_img: '',
    };
  },
  mounted: function() {
    let width = this.$el.clientWidth;
    let height = this.$el.clientHeight;

    if (width / height > 16/9) {
      this.width = width;
    } else {
      this.height = height;
    }

    if (width <= 854) {
      this.source = this.video['480p'];
    } else if (width <= 1279) {
      this.source = this.video['720p'];
    } else if (width > 1280) {
      this.source = this.video['1080p'];
    }

    if (width <= 1024) {
      this.poster_img = this.poster['large'];
    } else if (width <= 1200) {
      this.poster_img = this.poster['x-large'];
    } else if (width <= 1600) {
      this.poster_img = this.poster['xx-large'];
    } else {
      this.poster_img = this.poster['full'];
    }
  }
};
</script>

<style lang="scss">
.jumbotron-video {
  min-height: calc(100vh - 1.17vw);
  margin: 1.17vw 0 0 0 !important;
}

.video-outer {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgb($primary-color);
}

video {
  position: relative;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  -ms-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  z-index: 0;
  mix-blend-mode: luminosity
}

</style>